import AugcHistory from "@/pages/augc-history/page";
import type { RouteObject } from "react-router-dom";
import AdminLayout from "@/components/layout/AdminLayout";
import Home from "@/pages/home/page";
import Dashboard from "@/pages/dashboard/page";
import Devices from "@/pages/devices/page";
import Rental from "@/pages/rental/page";
import Scenes from "@/pages/scenes/page";
import SceneDetail from "@/pages/scenes/detail/page";
import GlobalQA from "@/pages/global-qa/page";
import KnowledgeOverview from "@/pages/knowledge/page";
import RoutesList from "@/pages/routes/page";
import RouteDetail from "@/pages/routes/route-detail/page";
import OpsOverview from "@/pages/ops/page";
import Audio from "@/pages/audio/page";
import KnowledgeLibrary from "@/pages/knowledge/library/page";
import MediaAssets from "@/pages/knowledge/media-assets/page";
import PackReleases from "@/pages/knowledge/releases/page";
import KnowledgeGraph from "@/pages/knowledge/graph/page";
import Faceswap from "@/pages/faceswap/page";
import Trips from "@/pages/trips/page";
import Games from "@/pages/games/page";
import Reports from "@/pages/reports/page";
import Analytics from "@/pages/analytics/page";
import Settings from "@/pages/settings/page";
import Videos from "@/pages/videos/page";
import ImageLibrary from "@/pages/image-library/page";
import Tracking from "@/pages/tracking/page";
import Capture from "@/pages/capture/page";
import OpsKnowledge from "@/pages/ops/knowledge/page";
import OpsReports from "@/pages/ops/reports/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      { path: "dashboard", element: <Dashboard /> },
      { path: "devices", element: <Devices /> },
      { path: "rental", element: <Rental /> },
      { path: "knowledge", element: <KnowledgeOverview /> },
      { path: "knowledge/scenes", element: <Scenes /> },
      { path: "knowledge/scenes/:id", element: <SceneDetail /> },
      { path: "knowledge/routes", element: <RoutesList /> },
      { path: "knowledge/routes/:routeId", element: <RouteDetail /> },
      { path: "knowledge/audio", element: <Audio /> },
      { path: "knowledge/graph", element: <KnowledgeGraph /> },
      { path: "knowledge/global-qa", element: <GlobalQA /> },
      { path: "knowledge/library", element: <KnowledgeLibrary /> },
      { path: "knowledge/media-assets", element: <MediaAssets /> },
      { path: "knowledge/releases", element: <PackReleases /> },
      { path: "faceswap", element: <Faceswap /> },
      { path: "augc-history", element: <AugcHistory /> },
      { path: "trips", element: <Trips /> },
      { path: "games", element: <Games /> },
      { path: "reports", element: <Reports /> },
      { path: "analytics", element: <Analytics /> },
      { path: "settings", element: <Settings /> },
      { path: "videos", element: <Videos /> },
      { path: "image-library", element: <ImageLibrary /> },
      { path: "tracking", element: <Tracking /> },
      { path: "capture", element: <Capture /> },
      { path: "ops", element: <OpsOverview /> },
      { path: "ops/knowledge", element: <OpsKnowledge /> },
      { path: "ops/reports", element: <OpsReports /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;